<template>
    <v-card class="p-4 w-100 mr-4 delegation">
        <v-toolbar class="shadow-none" style="flex: unset;" content-class="h-auto">
            <div class="custom-icon-wrapper">
                <v-icon @click="backToDashboardsPage()">custom-icon left-arrow-icon</v-icon>
            </div>
            <v-toolbar-title class="size-16 dark-text p-4 label">{{ $t("res_label_average_transfer_delay") }}</v-toolbar-title>
        </v-toolbar>
        <hr>
        <div class="container">
            <v-row>
                <v-col cols="6">
                    <v-label class="label_required mb-1">{{ $t("res_label_year") }}<span> *</span></v-label>
                    <multi-select class="light-bg add-arrow" v-model="tempFilter.fromYear" label="name"
                        :placeholder="$t('res_Label_Select')" track-by="id" open-direction="bottom" :options="year_items"
                        :searchable="false" :internal-search="false" :clear-on-select="false" :close-on-select="true"
                        :max-height="600" :show-no-results="false" :hide-selected="false"
                        :multiple="false">
                    </multi-select>
                </v-col>
                <v-col cols="6">
                    <v-label class="label_required mb-1">{{ $t("res_Label_SelectCategory") }}</v-label>
                    <multi-select class="light-bg add-arrow" v-model="tempFilter.categoriesList" label="name"
                        placeholder="Select Category" track-by="id" open-direction="bottom" :options="category_items"
                        :searchable="false" :internal-search="false" :clear-on-select="false" :close-on-select="false"
                        :options-limit="5" :max-height="600" :show-no-results="false" :hide-selected="false"
                        :multiple="true">
                        <template slot="noOptions">
                            {{ $t('res_Label_ListEmpty') }}
                        </template>
                    </multi-select>
                    
                </v-col>
            </v-row>
            <v-row>
                <div class="d-flex justify-space-between align-items-center ">
                    <v-checkbox v-if="false" v-model="tempFilter.getAllHierarchy" :label="getAllHierarchyLabel" class="mt-0"></v-checkbox>
                    <div class="d-flex gap-2">
                        <v-btn @click="clearFilter()" color="light-blue">{{ $t("res_ButtonText_Clear") }}</v-btn>
                        <v-btn dense class="primary" @click="updateFilter()">
                            {{ $t("res_ButtonText_Search") }}
                        </v-btn>
                    </div>
                </div>
            </v-row>
        </div>
        <hr>
        <div v-if="this.showcharts">
            <div class="row align-items-start m-0 gap-2">
                <v-card class="bg-white rounded-top-corners rounded-4">
                    <v-card-text class="dashboarCardTitle mt-2">
                        <p>{{ averageDelaydataSeries[0].headerLabel }}</p>
                        <p>({{ $t("res_label_year") }}: <span style="color: #1B9C85">{{ filter.fromYear }}</span>)</p>
                    </v-card-text>
                        <canvas id="delayValues" height="100px"></canvas>
                </v-card>
            </div>
        </div>
        <!-- <div v-if="items.length > 0">
            <div class="row align-items-start m-0 pt-5 gap-2">
                <v-card class="bg-white rounded-top-corners rounded-4">
                    <v-card-text class="dashboarCardTitle mt-2">
                        <p>{{ $t("res_label_average_per_structure") }}</p>
                        <p>({{ $t("res_label_year") }}: <span style="color: #1B9C85">{{ filter.fromYear }}</span>)</p>
                    </v-card-text>
                    <v-data-table :headers="structuresHeaders" :items="items" :items-per-page="10">
                        <template v-slot:[`item.name`]="{ item }">
                            <span style="color: #1B9C85; text-decoration: underline; cursor: pointer;"
                                @click="handleStructureClick(item)">
                                {{ item.name }}
                            </span>
                        </template>
                        <template v-slot:[`item.averageComparison`]="{ item }">
                            <span :style="{ color: item.averageComparison >= averageDelay ? '#1B9C85' : 'red' }">
                                {{ item.averageComparison <= averageDelay ? '+' : '-' }}{{ item.averageComparison }} </span>
                        </template>
                        <template v-slot:[`item.yearlyGraph`]="{ item }">
                            <v-icon @click="handleStructureGraph(item)">mdi-chart-line</v-icon>
                        </template>
                    </v-data-table>
                </v-card>
            </div>
        </div> -->
        <!-- <div v-if="showStructureGraph">
            <div class="row align-items-start m-0 pt-5 gap-2">
                <v-card class="bg-white rounded-top-corners rounded-4">
                    <v-card-text class="dashboarCardTitle mt-2">
                        <p>({{ $t("res_label_year") }}: <span style="color: #1B9C85">{{ filter.fromYear }}</span>)</p>
                    </v-card-text>
                    <canvas id="structureDelayValues" height="100px"></canvas>
                </v-card>
            </div>
        </div> -->
        <!-- <div v-if="showListUsers">
            <div class="row align-items-start m-0 pt-5 gap-2">
                <v-card class="bg-white rounded-top-corners rounded-4">
                    <v-card-text class="dashboarCardTitle mt-2">
                        <p>{{ $t("res_label_average_per_user") }}</p>
                        <p>(<span style="color: #1B9C85">{{ activeStructureName }}</span>)</p>
                    </v-card-text>
                    <v-data-table :headers="usersHeaders" :items="listUsers" :items-per-page="10">
                        <template v-slot:[`item.structureAverageComparison`]="{ item }">
                            <span
                                :style="{ color: item.averageComparison >= item.structureAverageComparison ? '#1B9C85' : 'red' }">
                                {{ item.averageComparison <= item.structureAverageComparison ? '+' : '-' }}{{
                                    item.structureAverageComparison }} </span>
                        </template>
                        <template v-slot:[`item.averageComparison`]="{ item }">
                            <span :style="{ color: item.averageComparison >= item.structureAverage ? '#1B9C85' : 'red' }">
                                {{ item.averageComparison <= averageDelay ? '+' : '-' }}{{ item.averageComparison }} </span>
                        </template>
                    </v-data-table>
                </v-card>
            </div>
        </div> -->
    </v-card>
</template>
<style scoped></style>
<script>
import constants from "@/assets/js/constants.js";
import axios from "axios";
import MultiSelect from 'vue-multiselect';
import * as utils from '@/assets/js/common.js';
import router from '../../router/index.js';
import { Chart, CategoryScale, LinearScale, LineController, LineElement, PointElement, Title, Tooltip, Legend } from 'chart.js';

export default {
    name: "AverageDelayDashboard",
    components: { MultiSelect },
    data() {
        const englishMonths = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ];
        const arabicMonths = [
            'يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو',
            'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'
        ];
        const isArabic = localStorage.getItem('lang') == 'ar';
        return {
            getAllHierarchyLabel: "",
            utils: utils,
            yearMenu: false,
            activeStructureName: "",
            showStructureGraph: false,
            showListUsers: false,
            averageDelay: 0,
            forListDto: {
                from: [],
                year: "",
                categories: [],
                getAllHierarchy: false
            },
            structuresHeaders: localStorage.getItem('lang') == 'ar' ?
                [
                    { text: 'الإدراة', value: 'name', 'sortable': false },
                    { text: 'المتوسط (أيام)', value: 'average', 'sortable': false },
                    { text: 'مقارنة مع المتوسط الكلي', value: 'averageComparison', 'sortable': false },
                    { text: 'الرسم البياني السنوي', value: 'yearlyGraph', 'sortable': false }
                ] : [
                    { text: 'To Structure', value: 'name', 'sortable': false },
                    { text: 'Average (Days)', value: 'average', 'sortable': false },
                    { text: 'Compare to Total Average', value: 'averageComparison', 'sortable': false },
                    { text: 'Yearly Graph', value: 'yearlyGraph', 'sortable': false }
                ],
            usersHeaders: localStorage.getItem('lang') == 'ar' ?
                [
                    { text: 'المستخدم', value: 'username', 'sortable': false },
                    { text: 'المتوسط (أيام)', value: 'average', 'sortable': false },
                    { text: 'مقارنة مع المتوسط الكلي للادارة', value: 'structureAverageComparison', 'sortable': false },
                    { text: 'مقارنة مع المتوسط الكلي', value: 'averageComparison', 'sortable': false },
                ] : [
                    { text: 'To User', value: 'username', 'sortable': false },
                    { text: 'Average (Days)', value: 'average', 'sortable': false },
                    { text: 'Compare to Structure Total Average', value: 'structureAverageComparison', 'sortable': false },
                    { text: 'Compare to Total Average', value: 'averageComparison', 'sortable': false },
                ],
            items: [],
            listStructuresIds: [],
            listUsers: [],
            listUsersIds: [],
            category_items: [],
            year_items: [],
            filterDialog: false,
            tempFilter: {
                categoriesList: [],
                fromYear: { id: new Date().getFullYear(), name: new Date().getFullYear() },
                getAllHierarchy: false
            },
            filter: {
                categoriesList: [],
                fromYear: "2023",
                getAllHierarchy: false
            },
            delayValues: [],
            structureDelayValues: [],
            averageDelaydataSeries: [{
                name: "Average delay in month",
                data: [],
                headerLabel: localStorage.getItem('lang') == 'ar' ? "المتوسط في السنة" : "Average per year"
            }],
            chartOptions: {
                responsive: true,
                maintainAspectRatio: true,
                plugins: {
                    title: {
                        display: true,
                        text: isArabic ? 'متوسط الإنجاز في الشهر' : 'Average Completion in Month',
                        color: '#024976',
                        font: {
                            size: 20,
                            weight: 'bold'
                        }
                    },
                    tooltip: {
                        enabled: true,
                        backgroundColor: 'rgba(0, 73, 118, 0.7)',
                        titleColor: '#fff',
                        bodyColor: '#fff'
                    }
                },
                animation: {
                    duration: 2000,
                    easing: 'easeInOutBounce'
                },
                scales: {
                    x: {
                        title: {
                            display: true,
                            text: isArabic ? 'الشهور' : 'Months',
                            color: '#024976'
                        },
                        grid: {
                            display: false
                        },
                        ticks: {
                            color: '#024976',
                            font: {
                                size: 14,
                                style: 'italic'
                            }
                        }
                    },
                    y: {
                        title: {
                            display: false,
                            text: isArabic ? 'جميع الفئات' : 'All Categories',
                            color: '#024976'
                        },
                        grid: {
                            color: 'rgba(2, 73, 118, 0.2)',
                            lineWidth: 1
                        },
                        ticks: {
                            color: '#024976',
                            font: {
                                size: 14,
                                style: 'italic'
                            }
                        }
                    }
                }
            },
            averageDelayStructuredataSeries: [{
                name: "Average delay in month",
                data: [],
                headerLabel: "Average Duration for Transfer Delay"
            }],
            structureChartOptions: {
                title: {
                    text: "",
                    floating: 0,
                    offsetY: 20,
                    align: "center",
                    style: {
                        color: "#444"
                    }
                },
                markers: {
                    seriesIndex: 0,
                    colors: '#0E21A0',
                    fillColor: '#0E21A0',
                    strokeColor: '#0E21A0',
                    size: 6,
                    shape: "circle"
                },
                chart: {
                    height: 350,
                    type: 'line',
                    color: '#0E21A0',
                    zoom: {
                        enabled: false
                    }
                },
                noData: {
                    text: "No Data",
                    align: "center",
                    verticalAlign: "middle",
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    colors: '#0E21A0',
                    curve: 'straight'
                },
                grid: {
                    row: {
                        colors: ['#f3f3f3', 'transparent'],
                        opacity: 0.5
                    },
                },
                xaxis: {
                    categories: localStorage.getItem('lang') == 'ar' ? arabicMonths : englishMonths,
                    title: {
                        text: 'All Categories'
                    }
                },
                yaxis: {
                    title: {
                        text: localStorage.getItem('lang') == 'ar' ? 'المتوسط (أيام)' : 'Average (Days)'
                    },
                },
            },
            charts: null,
            showcharts : false
        }
    },
    watch: {
        filter: {
            handler(newFilter) {
                this.getAverageDelay(newFilter.getAllHierarchy, newFilter.categoriesList, newFilter.fromYear);
            },
            deep: true,
        },
        delayValues: {
            handler(newDelayValues) {
                this.averageDelay = newDelayValues.reduce((acc, currentValue) => acc + currentValue, 0) / 12;
                this.chartOptions.plugins.title.text = localStorage.getItem('lang') == 'ar' ? `المتوسط ​​الكلي: ${this.averageDelay} ايام` : `Total Average: ${this.averageDelay} day(s)`;
                this.showcharts = true;
                this.buildCharts('delayValues','line')
            }
        },
        activeStructureName: {
            handler(newActiveStructureName) {
                this.structureChartOptions.title.text = newActiveStructureName;
                this.buildCharts('structureDelayValues','line')
            }
        }
    },
    methods: {
        fetchTypes() {
            axios.get(constants.baseApiUrl + "Admin/GetAllCategory?isDecreeEnabled="+constants.isDecreeEnabled+"&isCircularEnabled="+constants.isCircularEnabled)
            .then(response => 
            {
                const responseData = response.data;
                for (let i = 0; i < responseData.length; i++) {
                    const category = { id: responseData[i].id,  name: localStorage.getItem('lang') == 'en' ? responseData[i].name : responseData[i].nameAr };
                    if(category.id == 4 && !constants.isDecreeEnabled) continue;
                    if(category.id == 5 && !constants.isCircularEnabled) continue;
                    this.category_items.push(category);
                }
            }) 
            .catch((err) => console.warn(err))  
        },
        computeYearItems() {
            const currentYear = new Date().getFullYear();
            const maxYears = 10;
            const startYear = currentYear - maxYears + 1;
            this.year_items = Array.from({ length: maxYears }, (_, index) => {
                const year = startYear + index;
                return { name: year.toString(), id: year };
            });
        },

        buildCharts(chartId,chartType){
            const ctx = document.getElementById(chartId);

            if (this.charts) {
                this.charts.destroy();
            }
            const dataValues = chartId == 'delayValues'? this.averageDelaydataSeries[0].data : this.averageDelayStructuredataSeries[0].data;
                const monthNames = localStorage.getItem('lang') === 'ar' ?
                    ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'] :
                    ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

                const allValues = Array(12).fill(0).map((_, index) => {
                    return {
                        month: monthNames[index],
                        value: dataValues[index] !== undefined ? dataValues[index] : 0
                    };
                });

                this.charts = new Chart(ctx, {
                    type: chartType,
                    data: {
                        labels: allValues.map(item => item.month), 
                        datasets: [
                            {
                                label: localStorage.getItem('lang') == 'en'? 'Delay Values':'قيم التأخير',
                                backgroundColor: '#024976',
                                borderColor: '#024976',
                                data: allValues.map(item => item.value), 
                                fill: false,
                            },
                        ],
                    },
                    options: chartId == 'delayValues'? this.chartOptions: this.structureChartOptions
                });
        },
        handleStructureClick(item) {
            try {
                if (this.activeStructureName !== item.name) {
                    this.showStructureGraph = false;
                    this.activeStructureName = item.name;
                }
                this.listUsers = [];
                this.listUsersIds = [];
                this.showListUsers = true;
                axios.post(constants.baseApiUrl + `Dashboard/StructureUsers?fromStructureId=${item.id}`, { headers: constants.headers })
                    .then(res => {
                        if (res != undefined) {
                            res.data.forEach(element => {
                                var user = {
                                    id: element.id,
                                    name: localStorage.getItem('lang') == 'ar' ? element.nameAr : element.name,
                                    username: element.username,
                                    average: 0,
                                    structureAverage: item.average,
                                    structureAverageComparison: 0,
                                    averageComparison: 0
                                };
                                this.listUsers.push(user);
                                this.listUsersIds.push(user.id);
                            });
                        }
                        this.forListDto.from = this.listUsersIds;
                        this.forListDto.year = this.filter.fromYear;
                        this.forListDto.categories = this.filter.categoriesList;
                        this.forListDto.getAllHierarchy = this.filter.getAllHierarchy;
                    })
                    .catch(error => alert(error))
                    .finally(f => this.getAverageDelayforListUsers(this.forListDto))
            }
            catch (error) {
                console.log(error);
            }
        },
        handleStructureGraph(item) {
            if (this.activeStructureName !== item.name) {
                this.activeStructureName = item.name;
                this.structureDelayValues = [];
                this.showStructureGraph = false;
                this.showListUsers = false;
            }
            this.getAverageDelayFromStructure(this.tempFilter.getAllHierarchy, item.id, [], this.tempFilter.fromYear.id);
        },
        updateFilter() {
            if(this.tempFilter.fromYear == null) {
                window.showAlert("res_Msgs_FillRequired","warning");
                return ;
            }
            this.filter.fromYear = this.tempFilter.fromYear.id;
            this.filter.getAllHierarchy = this.tempFilter.getAllHierarchy;
            const categories = this.tempFilter.categoriesList.filter(category => category.id != 0);
            categories.forEach(category => this.filter.categoriesList.push(category.id));
        },
        clearFilter() {
            this.tempFilter.categoriesList = [];
            this.tempFilter.fromYear = { id: new Date().getFullYear(), name: new Date().getFullYear() };
            this.tempFilter.getAllHierarchy = false;
        },
        getAverageDelay(getAllHierarchy, categoriesList, fromYear) {
            try {
                this.delayValues = [];
                window.showLoading()
                axios.post(constants.baseApiUrl + `Dashboard/AverageTransferDelay?getAllHierarchy=${getAllHierarchy}&year=${fromYear}`, categoriesList, { headers: constants.headers })
                    .then(res => {
                        if (res != undefined) {
                            Object.values(res.data).forEach(value => {
                                this.delayValues.push(value);
                            });
                        }
                        this.showcharts = true;
                        this.buildCharts('delayValues','line');
                    })
                    .catch(error => alert(error));
            }
            catch (error) {
                console.log(error);
            }
            finally {
                this.averageDelaydataSeries[0].data = this.delayValues;
                if (this.filter.getAllHierarchy)
                    this.asyncStructuresTreeView();
                    window.hideLoading()
            }
        },
        getAverageDelayFromStructure(getAllHierarchy, fromStructure, categoriesList, fromYear) {
            try {
                this.structureDelayValues = [];
                axios.post(constants.baseApiUrl + `Dashboard/AverageTransferDelay?getAllHierarchy=${getAllHierarchy}&fromStructure=${fromStructure}&year=${fromYear}`, categoriesList, { headers: constants.headers })
                    .then(res => {
                        if (res != undefined) {
                            Object.values(res.data).forEach(value => {
                                this.structureDelayValues.push(value);
                            });
                            this.showStructureGraph = true;
                            this.buildCharts('structureDelayValues','line')
                        }
                    })
                    .catch(error => alert(error));
            }
            catch (error) {
                console.log(error);
            }
            finally {
                this.averageDelayStructuredataSeries[0].data = this.structureDelayValues;

            }
        },
        async getAverageDelayforListStructures(forListDto) {
            try {
                axios.post(constants.baseApiUrl + `Dashboard/AverageTransferDelayForListStructures`, forListDto, { headers: constants.headers })
                    .then(res => {
                        if (res != undefined) {
                            this.items.map(item => {
                                item.average = res.data[item.id];
                                item.averageComparison = res.data[item.id] - this.averageDelay;
                            });
                        }
                    })
                    .catch(error => alert(error))
            }
            catch (error) {
                console.log(error);
            }
        },
        async getAverageDelayforListUsers(forListDto) {
            try {
                axios.post(constants.baseApiUrl + `Dashboard/AverageTransferDelayForListUsers`, forListDto, { headers: constants.headers })
                    .then(res => {
                        if (res) {
                            this.listUsers.forEach((user, index) => {
                                user.average = res.data[user.id];
                                user.structureAverageComparison = res.data[user.id] - res.data[user.id];
                                user.averageComparison = res.data[user.id] - this.averageDelay;
                            });
                        }
                    })
                    .catch(error => alert(error))
                    .finally(f => { })
            }
            catch (error) {
                console.log(error);
            }
        },
        async asyncStructuresTreeView() {
            this.items = [];
            this.listStructuresIds = [];
            axios.get(constants.baseApiUrl + 'Admin/GetAllStructuresForOrganizationManagement')
                .then((res) => {
                    if (res.data != null) {
                        res.data.forEach(element => {
                            var item = {
                                id: element.id,
                                name: localStorage.getItem('lang') == 'ar' ? element.nameAr : element.name,
                                average: 0,
                                averageComparison: 0
                            };
                            this.items.push(item);
                            this.listStructuresIds.push(item.id);
                        });
                    }
                }).catch(err => console.warn(err))
                .finally(f => {
                    this.forListDto.from = this.listStructuresIds;
                    this.forListDto.year = this.filter.fromYear;
                    this.forListDto.categories = this.filter.categoriesList;
                    this.forListDto.getAllHierarchy = this.filter.getAllHierarchy;
                    this.getAverageDelayforListStructures(this.forListDto);
                })
        },
        backToDashboardsPage() {
            router.push({ name: 'dashboards' })
        },
    },
    async mounted() {
        this.fetchTypes();
        this.computeYearItems();
        this.getAllHierarchyLabel = window.translate("res_Label_getAllHierarchy");
        Chart.register(CategoryScale, LinearScale, LineController, LineElement, PointElement, Title, Tooltip, Legend);
    }
};
</script>
<style scoped>
.label {
    font-weight: 500;
    font-size: 12px;
}
</style>